import { render, staticRenderFns } from "./province_in.vue?vue&type=template&id=25758269&scoped=true"
import script from "./province_in.vue?vue&type=script&lang=js"
export * from "./province_in.vue?vue&type=script&lang=js"
import style0 from "./province_in.vue?vue&type=style&index=0&id=25758269&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25758269",
  null
  
)

export default component.exports